import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Form } from 'antd';

const SettingsFooter = ({ loading, handleSubmit, isDirty }) => {
  const { t } = useTranslation();
  return (
    <footer className="form-settings-screen-footer">
      <div className="form-settings-save-button-strip">
        <Form.Item>
          <Button
            type="primary"
            onClick={() => handleSubmit()}
            loading={loading}
            disabled={!isDirty}
          >
            {t('common.save')}
          </Button>
        </Form.Item>
      </div>
    </footer>
  );
};

export default SettingsFooter;
